"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RANKING_EXPORT_MIME = exports.RANKING_EXPORT_EVENT = exports.rankingExportSchema = exports.RANKING_EXPORT_MAX = void 0;
exports.needsALookLineOf = needsALookLineOf;
const zod_1 = require("zod");
const schemas_1 = require("./schemas");
// The Ranking page's Excel export (ADR 0069): the whole job, or only the people ticked, one sheet per tab.
/** The ranking comes back for at most this many people at once, so a selection can't be longer. */
exports.RANKING_EXPORT_MAX = 5_000;
/** `applicationIds` absent: everyone in the job. Present: only those people (the ticked rows). */
exports.rankingExportSchema = zod_1.z.object({ applicationIds: zod_1.z.array(schemas_1.uuidSchema).min(1).max(exports.RANKING_EXPORT_MAX).optional() });
/** One per file made: who exported which job, how many people and which columns were masked for them; never a candidate's data. */
exports.RANKING_EXPORT_EVENT = 'ranking.exported';
exports.RANKING_EXPORT_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
/** Why a person is in Needs a look, in words: no CV, a scan, or Jev gave up after three tries. */
function needsALookLineOf(cv) {
    if (cv === 'none')
        return 'No CV · read the application';
    if (cv === 'unreadable')
        return 'Scan or image only · read it yourself';
    return 'Jev couldn’t read this CV after three tries';
}
//# sourceMappingURL=ranking-export.js.map